import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import FilterModelPro, { GridFilterModelPro } from '../utils/filterModelPro'

export const filtroVazio: GridFilterModelPro = {
    items: [] as GridFilterModelPro['items'],
    quickFilterValue: '',
}

const useDefaultFilterModel = (
    initialFilterModel: GridFilterModelPro = {} as any,
    dontRedirect = false,
) => {
    const [searchParams] = useSearchParams()
    const urlFilter = searchParams.get('grid-filter')

    if (urlFilter && !dontRedirect) {
        const filter = FilterModelPro.fromUrlParams(urlFilter).filterModel
        if (filter.items.length) initialFilterModel = filter
        searchParams.delete('grid-filter')
        window.history.replaceState(
            {},
            '',
            `${window.location.pathname}?${searchParams}`,
        )
    }

    const [filterModel, setFilterModel] = useState<GridFilterModelPro>(() => {
        // Sem id, excluir/editar um item do filtro padrão casa todos os itens
        // (undefined === undefined) e afeta o filtro inteiro.
        const items = (initialFilterModel.items || []).map(item => ({
            ...item,
        }))
        for (const item of items)
            if (item.id === undefined) item.id = FilterModelPro.gerarID(items)

        return {
            items,
            quickFilterValue: initialFilterModel.quickFilterValue || '',
        }
    })
    return [filterModel, setFilterModel] as const
}

export default useDefaultFilterModel
